<template>
	<div class="winning-record">
		<div class="flex__around__center index__tab">
			<div
				class="flex__around tab-item"
				:class="loads.index==0?'tab-item--active':'tab-item'"
				@click="loads.index=0"
			>
				<span>全部</span>
			</div>
			<div
				class="flex__around tab-item"
				:class="loads.index==1?'tab-item--active':'tab-item'"
				@click="loads.index=1"
			>
				<span>未完成</span>
			</div>
			<div
				class="flex__around tab-item"
				:class="loads.index==2?'tab-item--active':'tab-item'"
				@click="loads.index=2"
			>
				<span>已完成</span>
			</div>
		</div>
        <div class='list-content'>
            <div class="flex__column item" v-for="(item,index) in list" :key="index">
                <div class="flex">
                    <img :src="item.cover_img">
                    <div class="flex__null__between ml_20">
                        <div class="flex__between item__right">
                            <span class="fs_24 c_4d">订单号:{{item.order_number}}</span>
                            <span class="c_FF9347 fs_28">{{item.status_name}}</span>
                        </div>
                        <span class="fs_24 c_4d">{{item.express_name}}{{item.express_number}}</span>
                        <span class="c_1a">{{item.title}}</span>
                        <span class="fs_24 c_4d">{{item.create_time}}</span>
                    </div>
                </div>

                <div class="flex__end__center item__footer">
                    <div class="flex">
                        <button class="button-left" v-link="'/Turntable/Perfect?id='+item.id">完善地址信息</button>
                        <button class="button-right" v-if="item.status=='待收货'" @click="sure(item.id)">确认收货</button>
                    </div>
                </div>
            </div>
        </div>
		<jc-list :url="'/Turntable/getMyOrder'" :loads="loads" @load="getList"></jc-list>
	</div>
</template>
<script>
export default {
	name: "WinningRecord",
	data() {
		return {
			loads: {
                user_id: localStorage.user_id,
				page: 1,
				index: 0
			},
			list: []
		};
	},
	mounted() {},
	methods: {
		getList(data) {
			this.list = data;
		},
		// 确认收货
		sure(e) {
			app.formSubmit(
				"/turntable/history_action",
				this,
				{ id: e.currentTarget.dataset.id },
				res => {
					if (res.code) {
						this.loadList(1);
					}
				}
			);
		}
	}
};
</script>
<style scoped>
.c_FF9347{
    color: #FF9347;
}
.winning-record {
	position: fixed;
	top: 0;
	bottom: 0;
	width: 100%;
	background:linear-gradient(159deg,rgba(254,176,56,1) 0%,rgba(255,100,71,1) 100%);
}
.index__tab {
	height: 100px;
}
.tab-item {
	height: 50px;
	font-size: 32px;
	color: #fff;
}
.tab-item--active {
	font-weight: bold;
	border-bottom: 6px solid #fff;
}
/* .list-content{
  position: fixed;
  top: 220px;
  bottom: 30px;
  left: 30px;
  width: 690px;
  background: #fff;
  border-radius: 10px;
} */
.list-content {
	position: fixed;
	top: 100px;
	bottom: 30px;
    padding: 0 30px;
    overflow: auto;
}
.list-content .item {
	width: 690px;
	padding: 30px 30px 20px;
	margin-top: 20px;
	border-radius: 10px;
	background: #fff;
}
.list-content .item:first-child {
	margin-top: 0;
}
.list-content .item img {
	width: 160px;
	height: 160px;
	background: #f5f5f5;
	border: 1px solid #e6e6e6;
	border-radius: 10px;
}
.item__right {
	width: 450px;
}
.item__footer {
	height: 80px;
}
.item__footer .button-left {
	width: 180px;
	height: 50px;
	border: 1px solid #cbcbcb;
	border-radius: 25px;
	line-height: 50px;
	font-size: 24px;
	color: #808080;
	background: none;
}
.item__footer .button-right {
	width: 140px;
	height: 50px;
	margin-left: 10px;
	border-radius: 25px;
	line-height: 50px;
	font-size: 24px;
	color: #1a1a1a;
	background: #ffce00;
	border: none;
}
.footer__tips {
	position: absolute;
	bottom: 0;
	width: 750px;
	height: 60px;
}
</style>




// WEBPACK FOOTER //
// src/pages/turntable/WinningRecord.vue